<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div class="card mb-2">
					<div class="card-body pb-0">
						<div class="row" v-if="dadosEscola.id == 0">
							<div class="col-12 mb-1">
								<label><i class="fas fa-school font-13 color-theme mr-1"></i><span class="font-14"> Escola: </span></label>
								<v-select title="Desktop" class="rounded" :options="listaEscolas" v-model="idEscola" label="nome" />
								<select title="Mobile" class="form-control" v-model="idEscola"> 
									<option v-for="(option, index) in listaEscolas" :key="index" :value="option">{{ option.nome }}</option>
								</select>
							</div>
						</div>
						<div class="row mt-2">
							<div class="col-md-4 col-6 mb-2">
								<label><i class="fas fa-calendar-alt font-13 color-theme mr-1"></i><span class="font-14"> Data inicial: </span></label>
								<input title="Mobile" class="form-control rounded" type="date" v-model="data1"/>
								<input title="Desktop" class="form-control rounded" type="date" v-model="data1"/>
							</div>
							<div class="col-md-4 col-6 mb-2">
								<label><i class="fas fa-calendar-alt font-13 color-theme mr-1"></i><span class="font-14"> Data final: </span></label>
								<input title="Mobile" class="form-control rounded" type="date" v-model="data2"/>
								<input title="Desktop" class="form-control rounded" type="date" v-model="data2"/>
							</div>
							<div class="col-6 col-lg-2 mb-3">
								<label><i class="far fa-chart-bar font-13 color-theme mr-1 cursor-pointer"></i> Estilo:</label>
								<v-select title="Desktop" :options="['Pizza','Colunas']" v-model="estiloGrafico" class="rounded"/>
								<select title="Mobile" class="form-control rounded" v-model="estiloGrafico">
									<option v-for="(option, index) in ['Pizza','Colunas']" :key="index" :value="option">{{ option }}</option>
								</select>
							</div>
							<div class="col-md-2 col mb-3">
								<button class=" btn btn-secondary w-100 ajusteBtn rounded" @click="pesquisarUsuario()">
									<i class="fa fa-search font-13"></i>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="this.relatorio != 0">
			<div class="card mb-2" v-if="estiloGrafico == 'Pizza'">
				<highcharts :options="chartPie"></highcharts>
			</div>
			<div class="card" v-else-if="estiloGrafico == 'Colunas'">
				<highcharts :options="chartColumn"></highcharts>
			</div>
		</div>
		<div class="modal-body my-5 text-center font-16" v-else>Nenhuma informação encontrada</div>

	</div>
</template>

<script>

import $ from 'jquery'
import { mapState } from 'vuex'


export default {
	name: 'Relatorio',
	data() {
		return {
			data1: '',
			data2: '',
			relatorio: [],
			estiloGrafico: 'Pizza',
			idEscola: '',
			listaEscolas: [
				{'id': 0, 'nome': 'Acesso Admin', }
			],
			chartPie: {
				chart: {
					type: 'pie',
					backgroundColor: 'transparent',
					height: 500,
				},
				title: {
					text: null,
					style: {
						color: 'var(--dark-color)',
						fontFamily: 'sans-serif'
					}
				},
				series: [
					{
						name: "Quantidade",
						data: []
					}
				]
			},
			chartColumn: {
				chart: {
					type: 'column',
					backgroundColor: 'transparent',
					height: 500,
					
				},
				title: {
					text: null,
					style: {
						color: 'var(--dark-color)',
						fontFamily: 'sans-serif'
					}
				},
				xAxis: {
					categories: [],
				},
				legend: {
					itemStyle: {
						color: 'var(--font-color)',
					},
					itemHoverStyle: {
						color: 'var(--primary-color)',
					},
				},
				series: [
					{
						name: 'Quantidade',
						data: [],
					},
				],
			},
		}
	},
	computed: {
		...mapState({
			urlRest: state => state.urlRest,
			dadosUsuario: state => state.dadosUsuario,
			dadosEscola: state => state.dadosEscola
		})
	},
	methods: {
		pesquisarUsuario: function () {
			let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)

			if(this.data2 != '' && this.data1 != '') {
				this.$axios({
					method: 'get',
					url: this.urlRest + 'service/getNivelEstresse',
					params: {
						data: this.data1,
						data2: this.data2,
						idEscola: this.idEscola.id
					}
				}).then(response => {
					ref.relatorio = response.data;
					this.atualizarGrafico()

				}).catch(function (error) {
					if (error.response != undefined) {
						if (error.response.status == 408) {
							ref.$store.dispatch('deslogar')

							ref.$toast.fire({
								icon: 'warning',
								title: 'Sessão expirada!'
							});
						} else {
							ref.$toast.fire({
								icon: 'error',
								title: 'Erro: ' + error.response.status
							});
						}
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: error
						});
					}
				}).finally(() => {
					this.$store.dispatch('alternarTelaCarregamento', false)
				});
			} else {
				ref.$toast.fire({
					icon: 'error',
					title: 'Preencha todas as datas! '
				})
				this.$store.dispatch('alternarTelaCarregamento', false)
			}
		},
		getEscola : function () {
			let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)

			this.$axios({
				method: 'get',
				url: this.urlRest + 'service/getEscola',
				params: {
					valor: ''
				},
				headers: {
                    'Content-Type': 'application/json'
                },
			}).then(response => {
				ref.listaEscolas = response.data;
				

			}).catch(function (error) {
				if (error.response != undefined) {
					if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

						ref.$toast.fire({
							icon: 'warning',
							title: 'Sessão expirada!'
						});
					} else {
						ref.$toast.fire({
							icon: 'error',
							title: 'Erro: ' + error.response.status
						});
					}
				} else {
					ref.$toast.fire({
						icon: 'error',
						title: error
					});
				}
			}).finally(() => {
				this.$store.dispatch('alternarTelaCarregamento', false)
			});
	
		},
		atualizarData() {
			let dataAtual = new Date().toISOString().substr(0, 10);
			this.data2 = dataAtual;
			dataAtual  = new Date(); // Obtém a data atual
			const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1); // Cria uma nova data usando o ano e mês atual, mas definindo o dia como 1
			const dataFormatada = primeiroDiaDoMes.toISOString().substr(0, 10); // Converte a nova data para o formato ISO e pega os primeiros 10 caracteres
			this.data1 = dataFormatada;
		},
		atualizarGrafico : function() {
			this.chartPie.series[0].data = [];
			this.chartColumn.series[0].data = [];

			this.relatorio.forEach(element => {
				this.chartPie.series[0].data.push({'name': element.pergunta, 'y': element.quantidade})
			});
			this.relatorio.forEach(element => {
				this.chartColumn.series[0].data.push({'name': element.pergunta, 'y': element.quantidade})
			});
		},
		fecharGrafico : function () {
			$('#modalGrafico').modal('hide')
		},
	},
	mounted() {
		this.atualizarData()
		this.getEscola()
		this.idEscola = this.dadosEscola
		this.pesquisarUsuario()
	}
}

</script>

<style scoped>
.btnFechar {
	color: white;
	background-color: #616161;
}

.aluno_card_image {
   width: 65px;
   float: left;
}

.aluno_card_corpo {
   margin-left: 75px;
}

.aluno_botao {
   right: 10px;
   top: 10px;
   position: absolute;
}

.aluno_botao button {
   margin: 3px;
   height: 60px;
   width: 60px;
}

.aluno_card_image img {
   width: 100%;
}


.switch input[type="checkbox"]:not(:checked)+.slider {
   background-color: #3c3e42
}

input[type="date"]::-webkit-calendar-picker-indicator {
   filter: invert(50%);
}

.slide-up-enter-active {
   transition: all 0.4s;
}

.slide-up-enter {
   transform: translateY(-100%);
   opacity: 0;
}

.slide-up-leave-to {
   transform: translateY(-100%);
   opacity: 0;
}

.custom-hover-class {
   background-color: red;
   color: white;
}

.unicoLimitador {
	overflow: hidden !important;
	display: -webkit-box !important;
	-webkit-line-clamp: 1 !important;
	-webkit-box-orient: vertical !important;
	line-break: anywhere !important;
}

.cards-3 {
   display: grid;
   grid-template-columns: 1fr 1fr;
   gap: 0.5rem;
   padding: 0;
   list-style-type: none;
}

.cards-4 {
   display: grid;
   grid-template-columns: 2.02fr 1fr;
   gap: 0.5rem;
   padding: 0;
   list-style-type: none;
}

.titleCard {
	color: 'var(--dark-color)';
	font-size: 22px;
}

.bodyCard {
	margin: auto;
}

.footerCard {
  margin-top: auto;
  margin-bottom: 15px;
}

@media screen and (min-width: 769px) {
	.ajusteBtn {
		margin-top: 29px;
	}
}


</style>